import type { Moment } from 'moment';
import type { EventDayInput, PersonalEventFieldsFragment } from 'graphql/types';

export function formatDayKey(dayKey: number) {
  const s = String(dayKey);
  if (s.length === 8) {
    return `${s.slice(0, 4)}.${s.slice(4, 6)}.${s.slice(6, 8)}`;
  }
  return s;
}

/** Map calendar day keys (YYYYMMDD) to GraphQL EventDayInput for the API. */
export function dateKeysToEventDays(dateKeys: number[]): EventDayInput[] {
  return dateKeys.map((dayKey): EventDayInput => {
    const s = String(dayKey);
    if (s.length === 8) {
      return { date: `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}` };
    }
    return { date: s };
  });
}

export function getPersonalEventDates(event: PersonalEventFieldsFragment) {
  const dates =
    event.eventDays?.data
      ?.map((day) => day.attributes?.date)
      .filter((date): date is number => date != null) ?? [];
  return [...dates].sort((a, b) => a - b);
}

export function stripHtml(html: string) {
  return html.replace(/<[^>]*>/g, '').trim();
}

/** Gregorian calendar day key stored on the backend (e.g. 20260529). */
export function momentToDateKey(day: Moment) {
  return Number(day.format('YYYYMMDD'));
}

/** Match stored day integers to the cell's Gregorian calendar date only. */
export function dayMatchesPersonalEventDate(day: Moment, dateKey: number) {
  const key = String(dateKey);
  if (key.length === 8) {
    return Number(day.format('YYYYMMDD')) === dateKey;
  }
  return day.date() === dateKey;
}
